import { useSession } from "src/contexts/AuthContext";
import { UserType } from "src/types/User";

export type CaseManagementAccess = {
  isEnabled: boolean;
};

/**
 * Dial is available to every authenticated admin. The agent rollout document
 * still controls generation and delivery behavior, but no longer controls who
 * can open the UI.
 */
export default function useIsCaseManagementEnabled(): CaseManagementAccess {
  const { metadata } = useSession();
  return { isEnabled: metadata?.type === UserType.Admin };
}
